import React from 'react'
import FavoriteActivityLoader from '../FavoriteActivityLoader'

const FavoriteActivitiesLoader = () => (
  <div>
    <FavoriteActivityLoader size={2} />
    <FavoriteActivityLoader />
  </div>
)

FavoriteActivitiesLoader.displayName = 'FavoriteActivitiesLoader'

export default FavoriteActivitiesLoader
